import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { SOLUTIONS, FRAMEWORK, BOOKING_URL } from "@/data/site";

export default function Solutions() {
  return (
    <div data-testid="solutions-page">
      <section className="pt-16 pb-16 md:pt-24 md:pb-20 border-b border-[#E5E5E5]">
        <div className="container-cc">
          <div className="overline mb-8"><span className="kicker-line" />Solutions</div>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02] max-w-5xl">
            Eight integrated solutions for the <span className="italic text-[#A60201]">entire employee experience.</span>
          </h1>
          <p className="mt-8 text-lg text-[#525252] max-w-2xl leading-relaxed">
            Each solution can be deployed standalone or stitched together as part of a long-term culture program. All grounded in our Listen → Design → Deliver → Measure framework.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E5E5] border border-[#E5E5E5] mb-20">
            {FRAMEWORK.map((f) => (
              <div key={f.step} className="bg-[#FAFAFA] p-7">
                <div className="font-serif-display text-4xl text-[#A60201]">{f.step}</div>
                <div className="font-serif-display text-xl mt-3">{f.title}</div>
                <div className="text-sm text-[#525252] mt-2 leading-relaxed">{f.desc}</div>
              </div>
            ))}
          </div>

          <div className="space-y-px bg-[#E5E5E5] border border-[#E5E5E5]">
            {SOLUTIONS.map((s, i) => (
              <div key={s.slug} id={s.slug} data-testid={`solution-${s.slug}`} className="bg-white p-8 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-8">
                <div className="lg:col-span-1 font-serif-display text-3xl text-[#A60201]">{String(i + 1).padStart(2, "0")}</div>
                <div className="lg:col-span-4">
                  <h3 className="font-serif-display text-3xl md:text-4xl leading-tight">{s.title}</h3>
                </div>
                <div className="lg:col-span-4 text-[#525252] leading-relaxed">{s.summary}</div>
                <div className="lg:col-span-3">
                  <ul className="space-y-3">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-start gap-2 text-sm">
                        <Check size={16} className="mt-0.5 text-[#A60201] flex-shrink-0" />
                        <span>{p}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-[#FEBE98]">
        <div className="container-cc">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <h2 className="font-serif-display text-4xl md:text-6xl leading-tight">Not sure where to start?</h2>
              <p className="mt-6 text-lg text-[#0A0A0A]/80 max-w-xl">Most engagements begin with a culture diagnostic. We listen first — to your people and your leadership intent — then propose where to invest.</p>
            </div>
            <div className="lg:col-span-5 flex flex-wrap gap-4 lg:justify-end">
              <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-primary" data-testid="solutions-book-call">Book Discovery Call <ArrowUpRight size={16} /></a>
              <Link to="/contact" className="btn-secondary" data-testid="solutions-contact">Share a brief</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
